const tags = {
  "notifications.tags.role.title": "Choose Your Role",
  "notifications.tags.role.body": "We'll personalize your experience.",
};

const subscription = {
  "notifications.subscription.info.message":
    "If you've recently purchased a subscription, please try refreshing your subscription by clicking the button below.",
  "notifications.subscription.refresh.message":
    "Please wait while we refresh your subscription, this may take a few moments. If this is taking longer than expected, please contact support at contact@beyourbest.com",
};

const demo = {
  "notifications.demo.expired.title": "Trial Access Expired",
  "notifications.demo.expired.message": "Your trial account access has expired and you no longer have access to Be Your Best training features.",
  "notifications.demo.expired.info.portal":
    "To continue using Be Your Best, please purchase a subscription plan or sign in with a different account.",
  "notifications.demo.expired.info.unity":
    "To continue using Be Your Best, please go to www.portal.beyourbest.com to purchase a subscription plan or sign in with a different account.",
  "notifications.demo.expired.info.promo": "Use {{code}} for {{discount}} this {{event}}.",
  "notifications.demo.expired.info.promo-code": "BF25",
  "notifications.demo.expired.info.promo-discount": "40% off annual subscriptions",
  "notifications.demo.expired.info.promo-event": "Black Friday",
  "notifications.demo.conversion.failed.title": "Failed to activate trial",
  "notifications.demo.conversion.failed.message": "Please try again by signing out and signing in again using the link provided in the email.",
};

export const notifications = {
  ...tags,
  ...subscription,
  ...demo,
};
